/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum KBatchDType {
    _36 = '36',
    _90 = '90',
    _98 = '98',
}
